"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var message_1 = __importDefault(require("./message"));
var attributes_1 = __importDefault(require("./attributes"));
var IMAGE_REGEX = /[(']cid:(.)*[)']/g;
var NeuralCleanConversation = /** @class */ (function (_super) {
    __extends(NeuralCleanConversation, _super);
    function NeuralCleanConversation(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.conversation = '';
        _this.modelVersion = '';
        _this.initAttributes(props);
        return _this;
    }
    NeuralCleanConversation.prototype.extractImages = function () {
        var _this = this;
        var f = [];
        if (this.conversation) {
            var fileIds = this.conversation.match(IMAGE_REGEX);
            if (fileIds) {
                // After applying the regex, if there are IDs found they would be
                // in the form of => 'cid:xxxx' (including apostrophes), so we discard
                // everything before and after the file ID (denoted as xxxx above)
                fileIds.forEach(function (id) { return __awaiter(_this, void 0, void 0, function () {
                    var parsedId, file;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                parsedId = id.substring(5, id.length - 1);
                                return [4 /*yield*/, this.connection.files.find(parsedId)];
                            case 1:
                                file = _a.sent();
                                f.push(file);
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
        }
        return Promise.resolve(f);
    };
    NeuralCleanConversation.collectionName = 'conversation';
    NeuralCleanConversation.attributes = __assign(__assign({}, message_1.default.attributes), { conversation: attributes_1.default.String({
            modelKey: 'conversation',
        }), modelVersion: attributes_1.default.String({
            modelKey: 'modelVersion',
            jsonKey: 'model_version',
        }) });
    return NeuralCleanConversation;
}(message_1.default));
exports.default = NeuralCleanConversation;
